import galleryProduct from '../js/modules/galleryProduct';
import productVariantsNav from '../js/modules/productVariantsNav';
import tabAccordion from '../js/modules/tabAccordion';
import rechargeHelper from '../js/modules/rechargeHelper';

// Layouts
import '../scss/layouts/grid_product.scss';
import '../scss/layouts/grid_ingredient-table.scss';
import '../scss/layouts/list_card-benefit.scss';
import '../scss/layouts/wrapper_product.scss';

// Elements
import '../scss/elements/badge_best-value.scss';
import '../scss/elements/btn_radio.scss';
import '../scss/elements/btn_basket.scss';
import '../scss/elements/btn_skip.scss';
import '../scss/elements/radio_option.scss';

// Blocks
import '../scss/blocks/card_benefit.scss';
import '../scss/blocks/display_price.scss';
import '../scss/blocks/nav_product-attributes.scss';
import '../scss/blocks/nav_product-variants.scss';
import '../scss/blocks/gallery_product.scss';
import '../scss/blocks/header_product.scss';
import '../scss/blocks/widget_ecologi.scss';
import '../scss/blocks/widget_recharge-subscriptions.scss';
import '../scss/blocks/widget_petclub.scss';
import '../scss/blocks/panel_buy.scss';
import '../scss/blocks/panel_brand-key-points.scss';
import '../scss/blocks/panel_help-advice.scss';
import '../scss/blocks/panel_feeding-guide.scss';
import '../scss/blocks/panel_product-description.scss';
import '../scss/blocks/panel_product-features.scss';
import '../scss/blocks/panel_product-reviews.scss';
import '../scss/blocks/panel_product-video.scss';
import '../scss/blocks/panel_section-collapse.scss';
import '../scss/blocks/tab_accordion.scss';

// Init modules
galleryProduct();
productVariantsNav();
tabAccordion();
rechargeHelper();
